import NavBarLegalComplianceEvaluation from './components/modules/LegalCompliance/NavBarLegalComplianceEvaluation';
import NavBarGlobalLegalComplianceEvaluation from './components/modules/GlobalLegalCompliance/NavBarGlobalLegalComplianceEvaluation';
import NavBarCorrectiveActionsTask from './components/modules/CorrectiveActions/NavBarCorrectiveActionsTask';
import NavBarResourceManager from './components/modules/ResourceManager/NavBarResourceManager';
import NavBarTotalEnergiesRisk from './components/modules/TotalEnergiesRisk/NavBarTotalEnergiesRisk';
import NavBarLegalCompliancePlantSelect from './components/modules/LegalCompliance/NavBarLegalCompliancePlantSelect';
import { Route, Routes } from 'react-router-dom';
import { routePath } from '@/routing/helpers/router';

const NavBarRightSwitch = () => (
  <Routes>
    <Route
      path={routePath('user_module_legalCompliance_evaluation')}
      exact
      element={<NavBarLegalComplianceEvaluation />}
    />
    <Route
      path={routePath('user_module_legalCompliance_home')}
      exact
      element={<NavBarLegalCompliancePlantSelect />}
    />
    <Route
      path={routePath('user_module_globalLegalCompliance_evaluation')}
      exact
      element={<NavBarGlobalLegalComplianceEvaluation />}
    />
    <Route
      path={routePath('user_module_correctiveActions_task_list')}
      exact
      element={<NavBarCorrectiveActionsTask />}
    />
    <Route
      path={routePath('user_module_resourceManager_resource_home')}
      exact
      element={<NavBarResourceManager view="resource" />}
    />
    <Route
      path={routePath('user_module_resourceManager_obligation_home')}
      exact
      element={<NavBarResourceManager view="obligation" />}
    />
    <Route
      path={routePath('user_module_totalEnergiesRisk_base')}
      exact={false}
      element={<NavBarTotalEnergiesRisk />}
    />
    <Route path="*" element={<></>} />
  </Routes>
);

export default NavBarRightSwitch;
